import { Box, Card, CardContent, Typography } from '@mui/material';
import { FC } from 'react';
import { TReportsDescriptionProps } from './types';

export const ReportsDescription: FC<TReportsDescriptionProps> = ({
	description,
	preserveLineBreaks,
}) => {
	return (
		<Card
			sx={{
				m: ' 0 10px 12px 10px',
				borderRadius: '12px',
				bgcolor: '#0092de24',
				'& .MuiCardContent-root': { padding: '8px 16px 0px 16px!important' },
				// width: 'calc(100% - 40px)',
			}}
		>
			<CardContent
				color="primary"
				sx={{
					color: 'primary.main',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						// mt: -2,
						borderRadius: '12px',
						padding: '10px',
						height: 'auto',
						// width: 'auto',
						// flexDirection: 'column',
					}}
				>
					<Typography
						sx={{
							fontSize: '3rem',
							color: 'primary.main',
							fontFamily: 'monospace',
							mr: 1.5,
							mt: -1,
							fontWeight: 'bold',
							textTransform: 'lowercase',
						}}
					>
						i
					</Typography>
					<Typography
						sx={{
							fontSize: '1rem',
							fontStyle: 'italic',
							color: 'primary.main',
							ml: '10px',
							...(preserveLineBreaks && { whiteSpace: 'pre-line' }),
						}}
					>
						{description}
					</Typography>
				</Box>
			</CardContent>
		</Card>
	);
};
